export const getSiteID = () => {
    switch (process.env.REACT_APP_PROJECT_COUNTRY) {
        case "uk":
            return 7;
        case "ie":
            return 8;
        case "us":
            return 9;
        default:
            return 7;
    }
};